import router from '@/router/router.config'
import Oidc, { User } from 'oidc-client'
import oidcConfig from './oidc-config'
import { UserProfile } from '@/config/types'
import store, { MutationTypes } from '@/store'
import { cptSearhStr, queryString } from '@/utils'
import request from "@/utils/request";
import menu, { MenuChildern } from '@/router/menu'
import { ApplicationConfigProvider } from '@/config/environment'

class UserManager {
  public manager: Oidc.UserManager = new Oidc.UserManager({
    ...oidcConfig,
    staleStateAge: 60
  })

  isGettingUserInfo: boolean = false

  constructor() {
    const manage = this.manager;

    // try {
    //   const search = queryString(location.search)
    //   if (search && search.auth) {
    //     this.manager.getUser = () => {
    //       const user = JSON.parse(search.auth)
    //       user.expires_in = 100
    //       return new Promise((resolve, reject) => {
    //         resolve(user)
    //       })
    //     }
    //   }

    // } catch (error) {
    //   console.log(error)
    // }

    const getUser = this.manager.getUser
    this.manager.getUser = () => {
      return new Promise<User | null>((resolve, reject) => {
        getUser.apply(manage).then((user: User | null) => {
          if (
            user &&
            !store.state.userInfo &&
            !this.isGettingUserInfo // 防止多次请求user接口
          ) {
            this.isGettingUserInfo = true

            request.get(
              'api/base/account/user'
            ).then((response: any) => {
              if (!response) {
                reject()
              }
              store.commit(MutationTypes.SET_USERINFO, response || null)
              if (response.permissions) {
                this.setUserMenu(response.permissions, response.isAdmin, response)
              }
              resolve(user)
            }).catch(reject).finally(() => {
              this.isGettingUserInfo = false
            })
          } else {
            resolve(user) // 无论 user 是否存在都 resolve， 不同的是 user 存在的时候，/account/user 接口返回用户信息之后再 resolve， 用于用户菜单的 permissions
          }
          store.commit(MutationTypes.SET_USER, user || {})

        }).catch(reject)
      })
    }
  }

  MakeUserManagerSetting(newConfig: any = {}) {
    return new Oidc.UserManager({
      ...oidcConfig,
      staleStateAge: 60,
      ...newConfig
    })
  }

  setUserMenu(permissions: string[], isAdmin: boolean, user) {

    let userRoute: string[] = []

    const perMenu = (MenuItem: MenuChildern) => {
      // 这里code可能是个数组表示多个权限都可以访问该路由
      const code = MenuItem.meta?.code as string | Array<string> | Function
      let hasPermission = isAdmin

      if (!hasPermission) {
        if (typeof code === 'string') {
          hasPermission = code === '' || permissions.includes(code)
        } else if (typeof code === 'function') {
          hasPermission = code(user)
        } else {
          code.forEach(co => {
            if (permissions.includes(co)) {
              hasPermission = true
            }
          })
        }
      }

      MenuItem.meta!.hasPermission = hasPermission

      if (MenuItem.path && hasPermission) {
        userRoute.push(MenuItem.path)
      }

      if (MenuItem.children) {
        MenuItem.children.forEach(ite => {
          perMenu(ite)
        })
      }
    }

    menu.forEach((MenuItem: MenuChildern) => {
      perMenu(MenuItem)
    })
    store.commit(MutationTypes.SET_USERMENU, menu)
    store.commit(MutationTypes.SET_USERROUTE, userRoute)
  }

  InitUser() {
    return new Promise<boolean>((resolve, reject) => {

      this.manager.getUser().then(user => {
        resolve(true)
      }).catch(reject)
      this.manager.clearStaleState()
    })
  }

  LoginSilentCallback() {

    this.manager.signinSilentCallback().then(() => {
      this.manager.clearStaleState()
    })
  }

  LoginCallback() {
    this.manager
      .signinRedirectCallback()
      .then(() => {
        this.InitUser().then(() => {
          const redirectUri: any = localStorage.getItem('redirectUri') ?? "/" 
          router.push(redirectUri)
        })
      })
      .catch(function (e) {
        if (e.message === 'No matching state found in storage') { 
          const { redirectUri, ...rest } = router.currentRoute.value.query
          const searchStr = cptSearhStr(rest)
          window.location.href = ApplicationConfigProvider.current.baseUrl + redirectUri + (searchStr ? `&${searchStr}` : '')
          return
        }
        alert(e)
      })
  }

  Login() {
    const redirectUri = window.location.pathname + window.location.search
    console.log('login.')
    localStorage.setItem('redirectUri', redirectUri);
    console.log('redirectUri', redirectUri)
    this.manager = this.MakeUserManagerSetting({
      redirect_uri: oidcConfig.redirect_uri
    })

    return this.manager.signinRedirect()
  }

  IsInPermission(code: string): boolean {
    const permissions = store.state.userInfo?.permissions
    return permissions!.includes(code)
  }
  /**
   * 判断权限编码中是否有父级编码的子级权限
   * 因为Lion King 如果只勾选子级权限，不会返回父级权限的
   * @param code 父级编码
   */
  IsHaveChildPermission(code: string): boolean {
    const permissions = store.state.userInfo?.permissions
    return permissions!.filter(x => x.startsWith(code)).length > 0
  }

  IsAdmin(): boolean {
    return store.state.userInfo?.isAdmin as boolean
  }

  Logout() {
    this.manager.signoutRedirect()
  }
}

const userManager = new UserManager()

export default userManager